import { authServiceAxiosClient } from '@/lib';
import { Nullable } from '@/types';
import { AppError, withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';
import { UserDetails } from '../types';

type Param = {
  uuid?: Nullable<string>;
};

type Response = {
  success: boolean;
  message: string;
  data: UserDetails;
};

type Return = UserDetails;

export type GetUser = {
  param: Param;
  return: Return;
};

export const getUser = withLogger(async ({ uuid }: Param): Promise<Return> => {
  if (!uuid)
    throw new AppError({
      type: 'user-fetching',
      message: 'Invalid uuid.',
    });

  const url = userSettingsAPIUrls.getUser + `/${uuid}`;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<Response>(url);
  return data;
});
